import { useState, useEffect, useRef, useMemo } from 'react';
import { Button, Modal } from "react-bootstrap";
import axios from 'axios';
import CircularProgress from "@mui/material/CircularProgress";
//import { auth } from '../firebase';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './Forum.css';
import BottomTabNavigation from './BottomTabNavigation';
import Konsensus_Constants from '../constants/index.js';
import { Paper, Stack, Box } from "@mui/material";
import AddForumOverlay from "./AddForumOverlay";
import { FaEyeSlash } from 'react-icons/fa';

var threadId = null;
  let forum_tags = [
    { id: "1", attributes: { name: "General" } },
    { id: "2", attributes: { name: "Trustee" } }
  ];

export default function Forum() {
  const scrollableDivRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [input, setInput] = useState('');
  const [forums, setForums] = useState({ data: [], links: {} });
  const [hidden_forums, setHiddenForums] = useState(null);
  const [id, setId] = useState('');
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [isFetching, setIsFetching] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [activeId, setActiveId] = useState(null);
  const [posts, setPosts] = useState([]);
  const [users, setUsers] = useState({});
  const [tags, setTags] = useState({});
  const activeForums = forums?.data?.find(d => d.id === activeId) ?? null;
  const [showOverlay, setShowOverlay] = useState(false);
  const [showHidden, setShowHidden] = useState(false);

  const toggleShowHidden = () => {
    setShowHidden(prev => !prev);
  };

  // Filter forums for display only - doesn't affect the stored data
  const displayForums = useMemo(() => {
    if (!Array.isArray(forums?.data)) return [];

    // Filter hidden forums only if showHidden is false
    if (hidden_forums && !showHidden) {
      let hidden_forums_data = hidden_forums.data?.data || hidden_forums.data || [];
      return forums.data.filter(
        forum => !hidden_forums_data.some(hf => hf.forumId === forum.id)
      );
    }

    return forums.data;
  }, [forums.data, hidden_forums, showHidden]);

  const checkLogin = async() => {
    if( window.location.href!='https://app.konsensus.tech/' && window.location.href!='https://app.dev.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/register' && window.location.href!='https://app.accept.konsensus.tech/forgotten_password'){
        try{
            let login_data = await Konsensus_Constants._retrieveDataLocal("login_response");
            let nem = await Konsensus_Constants._retrieveDataLocal("nem");
            setId(login_data.login_response.data.userId);
            setEmail(nem.nem.data.email);
            setUsername(nem.nem.data.username);
            console.log(login_data);
            if(login_data.login_response.data) {
                console.log("User ID: " + login_data.login_response.data.userId);
                let res = await fetch(Konsensus_Constants.FORUM_URL + '/api/users/' + login_data.login_response.data.userId + "?include=groups", {
                  headers: { 'Authorization': 'Token ' + login_data.login_response.data.token }
                });

                if (res.status === 200) {
                  const userData = await res.json();

                  // Debug: Log the entire response structure
                  console.log("Full userData response:", userData);
                  console.log("userData.data:", userData.data);
                  console.log("All relationships:", userData.data?.relationships);
                  console.log("Included array:", userData.included);

                  // If groups are only in included, get all groups from there
                  const allIncludedGroups = userData.included?.filter(item => item.type === 'groups') || [];
                  console.log("All groups in included:", allIncludedGroups);

                  // Since we can't determine which groups the user belongs to from relationships,
                  // we need to check if the groups in 'included' are the user's groups
                  // The fact they're included likely means they're associated with the user

                  let isTrustee = false;
                  let isAdmin = false;

                  if (allIncludedGroups.length > 0) {
                    isTrustee = allIncludedGroups.some(group =>
                      group.attributes?.nameSingular === 'Trustee' ||
                      group.attributes?.namePlural === 'Trustees'
                    );

                    isAdmin = allIncludedGroups.some(group =>
                      group.attributes?.nameSingular === 'Admin' ||
                      group.attributes?.namePlural === 'Admins'
                    );

                    // Log group names to debug
                    allIncludedGroups.forEach(group => {
                      console.log(`Group: ${group.attributes?.nameSingular || group.attributes?.namePlural}, ID: ${group.id}`);
                    });
                  }

                  console.log("Is trustee: " + isTrustee + " isAdmin:" + isAdmin);

                  if (isTrustee || isAdmin) {
                    forum_tags = [
                      { id: "1", attributes: { name: "General" } },
                      { id: "2", attributes: { name: "Trustee" } }
                    ];
                  } else {
                    forum_tags = [
                      { id: "1", attributes: { name: "General" } }
                    ];
                  }
                } else {
                  Konsensus_Constants.clear();
                  navigate('/', { state: { message: "Either your login has expired or you haven't confirmed e-mail yet!" } });
                }
            }
        } catch (error) {
          console.error(error);
          Konsensus_Constants.clear();
          navigate('/', { state: { message: "Either your login has expired or you haven't confirmed e-mail yet!" } });
        }
    }
    console.log(window.location.href);
  }

  useEffect(() => {
    checkLogin();
  },[])

  setInterval(async () => {
    checkLogin();
  }, 5 * 60 * 1000);

  useEffect(() => {
    loadHiddenForums();
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, [hidden_forums]);

    const hideForum = async(id) => {
      if (window.confirm("Are you sure you want to hide this discussion?")) {
        const AXIOS_CONFIG = {
            headers: {
                'Content-Type':'application/json'
            }
        }
        let nem = await Konsensus_Constants._retrieveDataLocal("nem");
        if( nem && nem.nem && nem.nem.data ){
            try{
                let response3 = await axios.post(Konsensus_Constants.NEM_URL+'/NEM/api/api.php/hide-forum', {userhash: nem.nem.data.userhash, forumId: id}, AXIOS_CONFIG);
                if( response3.data.error ){
                   console.log(response3.data.error);
                }else{
                   console.log(response3);
                   alert("Forum hidden!");
                   loadHiddenForums();
                }
            }catch( error ){
                console.log(error);
            }
        }
      }
    }

    const loadHiddenForums = async() => {
    if( window.location.href!='https://app.konsensus.tech/' && window.location.href!='https://app.dev.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/register' && window.location.href!='https://app.accept.konsensus.tech/forgotten_password'){
            const AXIOS_CONFIG = {
                headers: {
                    'Content-Type':'application/json'
                }
            }
            let nem = await Konsensus_Constants._retrieveDataLocal("nem");
            if( nem && nem.nem && nem.nem.data ){
                try{
                    let response3 = await axios.post(Konsensus_Constants.NEM_URL+'/NEM/api/api.php/hidden-forums', {userhash: nem.nem.data.userhash}, AXIOS_CONFIG);
                    if( response3.data.error ){
                       console.log(response3.data.error);
                       setHiddenForums(null);
                    }else{
                       setHiddenForums(response3);
                    }
                }catch( error ){
                    console.log(error);
                }
            }
        }
    }

    const fetchData = async (url = null, preserveScroll = false) => {
      const isInitialLoad = !url;

      // Save current scroll position if preserving
      let scrollPosition = 0;
      if (preserveScroll && scrollableDivRef.current) {
        scrollPosition = scrollableDivRef.current.scrollTop;
      }

      if (isInitialLoad) {
        setIsFetching(true);
      } else {
        setIsLoadingMore(true);
      }

      try {
        const login_data = await Konsensus_Constants._retrieveDataLocal("login_response");
        const token = login_data.login_response.data.token;

        const apiUrl = url || Konsensus_Constants.FORUM_URL + "/api/discussions";

        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Token " + token,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        let json = await response.json();

        // DON'T filter here - store the complete unfiltered data
        // ensure it always has a .data array
        if (!Array.isArray(json.data)) {
          json.data = [];
        }

        // If loading more, append to existing data
        if (!isInitialLoad) {
          setForums(prev => ({
            data: [...prev.data, ...json.data],
            links: json.links || {}
          }));
        } else {
          setForums({
            data: json.data,
            links: json.links || {}
          });
        }

        console.log("forums state:", json);

        // Posts map - merge with existing if loading more
        const postsMap = isInitialLoad ? {} : { ...posts };
        (json.included || [])
          .filter(obj => obj.type === "posts")
          .forEach(post => { postsMap[post.id] = post; });
        setPosts(postsMap);

        // Users map - merge with existing if loading more
        const userMap = isInitialLoad ? {} : { ...users };
        (json.included || [])
          .filter(obj => obj.type === "users")
          .forEach(user => { userMap[user.id] = user; });
        setUsers(userMap);

        // Tags map - merge with existing if loading more
        const tagsMap = isInitialLoad ? {} : { ...tags };
        (json.included || [])
          .filter(obj => obj.type === "tags")
          .forEach(tag => { tagsMap[tag.id] = tag; });
        setTags(tagsMap);

        // Restore scroll position if preserving
        if (preserveScroll && scrollableDivRef.current) {
          setTimeout(() => {
            if (scrollableDivRef.current) {
              scrollableDivRef.current.scrollTop = scrollPosition;
            }
          }, 0);
        }

      } catch (error) {
        console.error("fetchData error:", error);
      } finally {
        if (isInitialLoad) {
          setIsFetching(false);
        } else {
          setIsLoadingMore(false);
        }
      }
    };

    const loadMoreForums = () => {
      if (forums.links?.next && !isLoadingMore) {
        fetchData(forums.links.next);
      }
    };


    const handleSubmit = async (title, post, selectedTags = []) => {
      try {
        let login_data = await Konsensus_Constants._retrieveDataLocal("login_response");
        let AXIOS_CONFIG = {
          credentials: "include",
          headers: {
            'Accept': 'application/json',
            'Authorization': 'Token ' + login_data.login_response.data.token
          }
        }

        // Build tags data array from selected tag IDs
        const tagsData = selectedTags.map(tagId => ({
          type: "tags",
          id: tagId
        }));

        // If no tags selected, try to use General tag as fallback
        if (tagsData.length === 0) {
          const generalTag = Object.values(tags).find(t =>
            t.attributes?.name?.toLowerCase() === 'general'
          );
          tagsData.push({
            type: "tags",
            id: generalTag ? generalTag.id : "1"
          });
        }

        let response2 = await axios.post(Konsensus_Constants.FORUM_URL + '/api/discussions', {
          "data": {
            "type": "discussions",
            "attributes": {
              "title": title,
              "content": post
            },
            "relationships": {
              "tags": {
                "data": tagsData
              }
            }
          }
        }, AXIOS_CONFIG);

        navigate('/forum/' + response2.data.data.id);
      } catch (error) {
        console.error(error);
      }
    };

  return (
    <Box sx={{
                 height: "100vh",
                 width: "100vw",
                 display: "flex",
                 flexDirection: "column",
                 overflow: "hidden",
                 position: "fixed",
                 top: 0,
                 left: 0
               }}>
       <Paper elevation={3} sx={{ p: 2 }}>
           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
             <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
               <img src={require('../assets/images/banner.png')}
                             style={{
                              height: 97,
                              width: 380,
                              marginBottom: 0,
                              marginTop: 20,
                             }}/>
             </div>
             <div style={{ display: 'flex', gap: 8 }}>
              <Button onClick={() => setShowOverlay(true)} style={{               backgroundColor: "#00aaaf",
                                                                                      borderColor: "#00aaaf",
                                                                                      fontSize: 12,
                                                                                      padding: '6px 12px'}} className="chat-rounded2">+ Add Discussion</Button>
              <Button
                onClick={toggleShowHidden}
                style={{               backgroundColor: "#00aaaf",
                                           borderColor: "#00aaaf",
                                           fontSize: 12,
                                           padding: '6px 12px'}}
                className="chat-rounded2"
              >
                {showHidden ? "Hide Discussions" : "Show Hidden Discussions"}
              </Button>
             </div>
           </div>
       </Paper>
      <Paper elevation={3}
                     sx={{
                       flex: 1,
                       width: "100%",
                       p: 2,
                       overflow: "hidden",
                       display: "flex",
                       flexDirection: "column"
                     }}>
          {isFetching ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <div
                ref={scrollableDivRef}
                style={{
                  flex: 1,
                  overflowY: "auto",
                  paddingBottom: 20,
                  marginBottom: 40,
                }}>
                {displayForums.map((item, index) => {
                  const userId = item.relationships?.user?.data?.id;
                  const user = userId ? users[userId] : null;

                  const tagId1 = item.relationships?.tags?.data?.[0]?.id;
                  const tag = tagId1 ? tags[tagId1] : null;

                  const tagId2 = item.relationships?.tags?.data?.[1]?.id;
                  const tag1 = tagId2 ? tags[tagId2] : null;

                  const firstPostId = item.relationships?.firstPost?.data?.id;
                  const firstPost = firstPostId ? posts[firstPostId] : null;

                  let days = "";
                  let hours = "";
                  if (firstPost?.attributes?.createdAt) {
                    const yourDate = new Date(firstPost.attributes.createdAt);
                    const now = new Date();
                    const diffMs = now - yourDate;
                    days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                    hours = Math.floor(diffMs / (1000 * 60 * 60));
                  }

                  const displayName = user?.attributes?.displayName ?? user?.attributes?.username ?? "Unknown";
                  const avatarInitial = displayName[0] ?? "?";

                    return (
                        <div key={item.id} style={styles.post}>
                          <div style={styles.userContainer}>
                            {user?.attributes?.avatarUrl ? (
                              <div style={styles2.avatar} className="avatar">
                                <img
                                  src={user.attributes.avatarUrl}
                                  style={styles2.avatar}
                                  className="avatar"
                                />
                              </div>
                            ) : (
                              <div
                                style={{ ...styles2.avatar, ...styles2.avatarPlaceholder }}
                                className="avatar avatarPlaceholder"
                              >
                                {avatarInitial}
                              </div>
                            )}

                            <div style={{ float: "right", display: "flex" }}>
                              <button
                                onClick={() => hideForum(item.id)}
                                style={{ background: "none", border: "none", cursor: "pointer" }}
                                aria-label="Hide Forum"
                                title="Hide Conversation"
                              >
                                <FaEyeSlash color="#00aaaf" />
                              </button>
                            </div>

                            <div
                              key={index}
                              onMouseEnter={() => setHoveredIndex(index)}
                              onMouseLeave={() => setHoveredIndex(null)}
                              style={{
                                background: hoveredIndex === index ? "#e7f4f6" : "#fff",
                                color: "#00aaaf",
                              }}
                              onClick={() => {
                                setActiveId(item.id);
                                navigate("/forum/" + item.id);
                              }}
                              className="forum-item"
                            >
                              <div style={{ float: "right", display: "flex" }}>
                                {tag && (
                                  <div style={{ float: "left", width: 200 }}>
                                    {tag?.attributes?.name}
                                  </div>
                                )}
                                {tag1 && (
                                  <div style={{ float: "left", width: 200 }}>
                                    {tag1?.attributes?.name}
                                  </div>
                                )}
                                <div>
                                  <span className="DiscussionListItem-count">
                                    <span aria-hidden="true">
                                      &nbsp;{(item.attributes?.commentCount ?? 1) - 1}
                                    </span>
                                    <span className="visually-hidden">0 replies</span>
                                  </span>
                                </div>
                              </div>
                              {item.attributes?.title}
                              <div style={styles.username} className="username">
                                {displayName}
                                {firstPost &&
                                  (hours > 24
                                    ? ` started ${days} days ago`
                                    : ` started ${hours} hours ago`)}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                })
              }
              </div>

              {/* Load More Button */}
              {forums.links?.next && (
                <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 20 }}>
                  <Button
                    onClick={loadMoreForums}
                    disabled={isLoadingMore}
                    style={{
                      backgroundColor: "#00aaaf",
                      borderColor: "#00aaaf",
                      fontSize: 12,
                      padding: '6px 12px',
                      marginBottom: 30,
                    }}
                    className="chat-rounded2"
                  >
                    {isLoadingMore ? (
                      <>
                        <CircularProgress size={16} style={{ marginRight: 8, color: 'white' }} />
                        Loading...
                      </>
                    ) : (
                      'Load More Discussions'
                    )}
                  </Button>
                </div>
              )}
            </>
          )}
      </Paper>
      {showOverlay && (
      <AddForumOverlay
        handleSubmit={handleSubmit}
        onClose={() => setShowOverlay(false)}
        tags={forum_tags}
      />
      )}
      <BottomTabNavigation />
    </Box>
  );
}
const styles2 = {
  container: { padding: 16, paddingTop:10, flex: 1 },
  commentCount: { fontSize: 16, marginBottom: 14 },
  postsContainer: { marginTop: 10 },
  post: { marginBottom: 23 },
  userContainer: { flexDirection: 'row', alignItems: 'center', marginBottom: 4 },
  avatar: { width: 36, height: 36, borderRadius: 18, marginRight: 10, backgroundColor: '#e7f4f6', float: "left", display: 'flex', alignItems: 'center', justifyContent: 'center',},
  avatarPlaceholder: { backgroundColor: '#e7f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#00aaaf', },
  userInfo: { flexDirection: 'column' },
  username: { fontSize: 16, fontWeight: '600' },
  postMeta: { fontSize: 12, color: '#888' },
  hr: { height: 1, backgroundColor: '#ddd', marginTop: 8, marginBottom: 4 },
};